import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import { AppBar, Toolbar, Box, Button, Avatar, IconButton } from "@mui/material";
import logoEmpresa from "../media/logoempresa.png";
import { getopcinesMenu } from "../services/apis";
import { clearAuthSession, hasAuthSession } from "../services/authStorage";
import {
  ROUTE_ACCESS_CHANGED_EVENT,
} from "../services/routeAccess";
import { isExternalUrl, normalizeExternalUrl } from "../utils/navigationLinks";

import TodayIcon from "@mui/icons-material/Today";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import LogoutIcon from "@mui/icons-material/Logout";

const iconMapping = {
  TodayIcon: <TodayIcon />,
  FolderSpecialIcon: <FolderSpecialIcon />,
};

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [tokenusu, setTokenUsu] = useState("");
  const [opciones, setOpciones] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const aliveRef = useRef(true);
  const isLogged = hasAuthSession();
  const isLoginRoute = location.pathname.startsWith("/login");
  const shouldRenderHeader = isLogged && !isLoginRoute;

  useEffect(() => {
    aliveRef.current = true;

    setTokenUsu(localStorage.getItem("DesRepresentante") || localStorage.getItem("username") || "");

    if (!shouldRenderHeader) {
      if (aliveRef.current) {
        setOpciones([]);
        setLoaded(true);
      }
      return () => {
        aliveRef.current = false;
      };
    }

    const cargarOpciones = async () => {
      try {
        setLoaded(false);

        const result = await getopcinesMenu();
        const data = Array.isArray(result?.data)
          ? result.data
          : Array.isArray(result)
            ? result
            : [];

        if (aliveRef.current) {
          setOpciones(data);
          setLoaded(true);
        }
      } catch (error) {
        console.error("Error al cargar opciones AppBar:", error);

        if (aliveRef.current) {
          setOpciones([]);
          setLoaded(true);
        }
      }
    };

    cargarOpciones();

    const handleRouteAccessChanged = () => {
      if (!aliveRef.current) {
        return;
      }

      void cargarOpciones();
    };

    window.addEventListener(ROUTE_ACCESS_CHANGED_EVENT, handleRouteAccessChanged);

    return () => {
      aliveRef.current = false;
      window.removeEventListener(ROUTE_ACCESS_CHANGED_EVENT, handleRouteAccessChanged);
    };
  }, [navigate, shouldRenderHeader]);

  const cerrarSesionDirecta = () => {
    clearAuthSession();
    setTokenUsu("");
    navigate("/login", { replace: true });
  };

  if (!shouldRenderHeader) {
    return null;
  }

  return (
    <AppBar position="sticky" elevation={1} sx={{ width: "100%" }}>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          minHeight: 64,
          px: 2,
          boxSizing: "border-box",
        }}
      >
        <Box
          component={RouterLink}
          to="/"
          sx={{ display: "flex", alignItems: "center", cursor: "pointer", flexShrink: 0 }}
          aria-label="Ir al inicio"
        >
          <img
            src={logoEmpresa}
            alt="Logo empresa"
            style={{ height: 40, width: "auto", maxWidth: "100%" }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexGrow: 1,
            justifyContent: "center",
            overflowX: "auto",
            minWidth: 0,
            px: 2,
          }}
        >
          {loaded &&
            opciones
              .filter((opcion) => opcion?.tipo === 0)
              .map((opcion) => (
                <Button
                  key={opcion.id}
                  color="inherit"
                  startIcon={iconMapping[opcion.icon] || null}
                  component={isExternalUrl(opcion.url) ? "a" : RouterLink}
                  href={isExternalUrl(opcion.url) ? normalizeExternalUrl(opcion.url) : undefined}
                  to={isExternalUrl(opcion.url) ? undefined : opcion.url}
                  target={isExternalUrl(opcion.url) ? "_blank" : undefined}
                  rel={isExternalUrl(opcion.url) ? "noopener noreferrer" : undefined}
                  sx={{ whiteSpace: "nowrap", flexShrink: 0, textTransform: "none" }}
                >
                  {opcion.nombre}
                </Button>
              ))}


        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexShrink: 0 }}>
          <Avatar sx={{ width: 32, height: 32, bgcolor: "#1976d2" }}>
            {tokenusu ? tokenusu.charAt(0) : isLogged ? "U" : "?"}
          </Avatar>

          {isLogged && (
            <IconButton
              size="small"
              color="inherit"
              onClick={cerrarSesionDirecta}
              sx={{
                bgcolor: "rgba(255,255,255,0.12)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
              }}
              title="Cerrar sesión"
            >
              <LogoutIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
